import React, { useState, useEffect } from "react";
import FilterComponent from "../Layout/FilterComponent";
import SearchExportComponent from "../Layout/SearchExportComponent";
import TableLayout from "../Layout/TableLayout";
import Pagination from "../Layout/Pagination";
import DetailBox from "./DetailBox";
import SearchExportFilterComponent from "../Layout/SearchExportFilterComponent";
import { getExportSalesReport } from "../../actions/SalesReportAction";
import { COMPANIES, DOCTORS } from "../../constants/fetchData";
import { getDistributorNames, getExportData } from "../../Common/functions";
import { getDoctorsForApplicationSale, getSalesReportsForExport } from "../../services/salesReportService"; // Add this import
import { RetrieveItemGroups } from "../../services/applicationReport";

const SalesReportOverview = ({
  data,
  loading,
  currentPage,
  totalPages,
  totalCount,
  setCurrentPage,
  userRole,
  setSearchTerm,
  filters,
  setFilters,
  itemsPerPage,
  setItemsPerPage,
}) => {
  const [openDetailBox, setOpenDetailBox] = useState(false);
  const [selectedObject, setSelectedObject] = useState([]);
  const [doctorsNameList, setDoctorsNameList] = useState([]);
  const [productGroupList, setProductGroupList] = useState([]); // NEW: State for product groups
  const [productNameList, setProductNameList] = useState([]);
  const [currentSearchTerm, setCurrentSearchTerm] = useState(""); // Local search term state
  const [visibleHeaders, setVisibleHeaders] = useState([
    "dates",
    "doctorsname",
    "distributor_name",
    // "application_specialist_name",
    "product_code",
    "quantity",
    "value",
    "action",
  ]);

  const tableHeaders = [
    { label: "Date", value: "dates" },
    { label: "Distributor", value: "distributor_name" },
    {
      label: "Application specialist",
      value: "username",
    },
    { label: "Owner", value: "username" },
    { label: "Doctor", value: "doctorsname" },
    { label: "Product Name", value: "product_code" },
    { label: "Patient Email", value: "patientemail" },
    { label: "Group Name", value: "group_title" },
    { label: "Product Group", value: "product_group" },
    { label: "Category", value: "category" },
    { label: "UnitPrice", value: "unit_price" },
    { label: "Quantity", value: "quantity" },
    { label: "Value", value: "value" },
    { label: "Status", value: "tracking_status" },
    // { label: "Sales Order_Status", value: "sales_order_status" },
    { label: "Action", value: "action" },
  ];

  // Get doctors list based on distributor name
  const getDoctors = async (distributorName) => {
    if (!distributorName) {
      setDoctorsNameList([]);
      return;
    }
    
    try {
      const result = await getDoctorsForApplicationSale({
        Distributor_Name: distributorName
      });
      setDoctorsNameList(result?.data?.records || []);
    } catch (error) {
      console.error("Error fetching doctors:", error);
      setDoctorsNameList([]);
    }
  };

  // Handle distributor change from FilterComponent
  const handleDistributorChange = (distributorName) => {
    getDoctors(distributorName);
  };

    // NEW: Get product groups
  const getProductGroups = async () => {
    try {
      const result = await RetrieveItemGroups(1747653662341);
      const groups = result?.data?.text?.itemgroups || [];
      setProductGroupList(groups);
    } catch (error) {
      console.error("Error fetching product groups:", error);
      setProductGroupList([]);
    }
  };

  // NEW: Get product names based on selected product group
  const getProductNames = (productGroupId) => {
    if (!productGroupId) {
      setProductNameList([]);
      return;
    }

    const selectedGroup = productGroupList.find(group => group.group_name === productGroupId);
    if (selectedGroup && selectedGroup.items) {
      setProductNameList(selectedGroup.items);
    } else {
      setProductNameList([]);
    }
  };

  // NEW: Load product groups on component mount
  useEffect(() => {
    getProductGroups();
  }, []);

  // NEW: Handle product group change from FilterComponent
  const handleProductGroupChange = (productGroupId) => {
    getProductNames(productGroupId);
  };

  // // Effect to fetch doctors when filters change (for Apply button)
  // useEffect(() => {
  //   if (filters.distributorName) {
  //     getDoctors(filters.distributorName);
  //   } else {
  //     setDoctorsNameList([]);
  //   }
  // }, [filters.distributorName]);

  const filterFields = [
    {
      type: "dropdown",
      label: "Distributor name",
      id: "distributorName",
      options:
        userRole === "super_admin"
          ? COMPANIES
          : getDistributorNames().map((item) => ({ value: item, label: item })),
    },
    {
      type: "dropdown",
      label: "Doctor name",
      id: "doctorName",
      options: doctorsNameList.length > 0 
        ? doctorsNameList.map((doctor) => ({ value: doctor.Full_Name || doctor, label: doctor.Full_Name || doctor }))
        : [], // Use dynamic doctors list instead of static DOCTORS
    },
    {
      type: "dropdown",
      label: "Choose team",
      id: "chooseTeam",
      options: [
        { value: "Avana_Employee", label: "Internal User" },
        { value: "Distributor", label: "Distributor" },
        { value: "Distributor_Admin", label: "Distributor Admin" },
      ],
    },
    {
      type: "dropdown",
      label: "Product group",
      id: "productGroup",
      options: productGroupList.length > 0 
        ? productGroupList.map((group) => ({ 
            value: group.group_name, 
            label: group.group_name 
          }))
        : [], // NEW: Dynamic product group options
    },
    {
      type: "dropdown",
      label: "Product name",
      id: "productName",
      options: productNameList.length > 0 
        ? productNameList.map((item) => ({ 
            value: item.name, 
            label: item.name 
          }))
        : [], // NEW: Dynamic product name options
    },

    { type: "date", label: "From Date", id: "fromDate" },
    { type: "date", label: "To Date", id: "toDate" },
  ];

  const handleApplyFilters = async (appliedFilters) => {
    // If distributor changed, reset doctor selection and fetch new doctors
    if (appliedFilters.distributorName !== filters.distributorName) {
      appliedFilters.doctorName = "";
      
      // Fetch doctors for the new distributor
      if (appliedFilters.distributorName) {
        await getDoctors(appliedFilters.distributorName);
      } else {
        setDoctorsNameList([]);
      }
    }

    // NEW: If product group changed, reset product name selection and fetch new product names
    if (appliedFilters.productGroup !== filters.productGroup) {
      appliedFilters.productName = "";
      
      // Fetch product names for the new product group
      if (appliedFilters.productGroup) {
        getProductNames(appliedFilters.productGroup);
      } else {
        setProductNameList([]);
      }
    }

    setFilters(appliedFilters);
  };

  const handleResetFilters = () => {
    setFilters({});
    setDoctorsNameList([]); // Clear doctors list when resetting
    setProductNameList([]); // NEW: Clear product names list when resetting
  };

  const handleSearch = (term) => {
    setCurrentSearchTerm(term);
    setSearchTerm(term);
  };
  const handleItemsPerPageChange = (newItemsPerPage) => {
    setItemsPerPage(newItemsPerPage);
    setCurrentPage(1);
  };
  const handlePageChange = (page) => setCurrentPage(page);
  
  const handleExport = async () => {
    try {
      // Show loading state or disable export button
      console.log("Starting export process...");
      
      let distributorName;
      if (userRole === "super_admin") {
        distributorName = filters.distributorName;
      } else if (userRole === "manager") {
        distributorName =
          !filters.distributorName || filters.distributorName.trim() === ""
            ? getDistributorNames()
            : filters.distributorName;
      } else {
        distributorName = getDistributorNames();
      }

      const exportFilters = {
        category: "sales tracking",
        tracking_status: "Sale",
        start_date: filters.fromDate,
        end_date: filters.toDate,
        distributor_name: distributorName,
        doctorsname: filters.doctorName,
        group_title: filters.chooseTeam,
        product_group: filters.productGroup,
        product_code: filters.productName,
        search_term: currentSearchTerm,
      };

      const result = await getSalesReportsForExport(exportFilters);
      
      if (result?.data?.items) {
        console.log(`Export completed: ${result.data.items.length} records fetched`);
        return result.data.items; // Return the data for the export dialog
      } else {
        console.error("No data received for export");
        return [];
      }
    } catch (error) {
      console.error("Error during export:", error);
      return [];
    }
  };

  const handleViewAction = (item) => {
    console.log("view");
    console.log("item", item);
    setSelectedObject(item);
    setOpenDetailBox(true);
  };
  const computedData = data.map((item) => ({
    ...item,
    value: (item.unit_price || 0) * (item.quantity || 0),
  }));

  // Function to get export data with computed values
  const getComputedExportData = (dataToExport) => {
    const computedDataForExport = dataToExport.map((item) => ({
      ...item,
      value: (item.unit_price || 0) * (item.quantity || 0),
    }));
    return getExportData(computedDataForExport, tableHeaders, visibleHeaders);
  };

  const exportData = getExportData(computedData, tableHeaders, visibleHeaders);
  return (
    <div className="px-0 sm:px-4 pt-2">
      {userRole === "super_admin" || userRole === "manager" ? (
        <>
          <div className="hidden sm:block">
            <FilterComponent
              fields={filterFields}
              onApply={handleApplyFilters}
              onReset={handleResetFilters}
              onDistributorChange={handleDistributorChange}
              onProductGroupChange={handleProductGroupChange}
            />
          </div>
          <SearchExportComponent
            exportFileName="SalesReport"
            onSearch={handleSearch}
            onExport={handleExport}
            // searchPlaceholder="Search"
            tablefields={tableHeaders}
            selectedHeaders={visibleHeaders}
            onHeadersChange={setVisibleHeaders}
            fields={filterFields}
            onApply={handleApplyFilters}
            onReset={handleResetFilters}
            exportData={exportData}
            onDistributorChange={handleDistributorChange}
            getComputedExportData={getComputedExportData}
          />
        </>
      ) : (
        <div className="mt-6">
          <SearchExportFilterComponent
            exportFileName="SalesReport"
            onSearch={handleSearch}
            onExport={handleExport}
            // searchPlaceholder="Search"
            tablefields={tableHeaders}
            selectedHeaders={visibleHeaders}
            onHeadersChange={setVisibleHeaders}
            fields={filterFields}
            onApply={handleApplyFilters}
            onReset={handleResetFilters}
            exportData={exportData}
            onDistributorChange={handleDistributorChange}
            getComputedExportData={getComputedExportData}
            // ExportOptionVisisbility={userRole !== "manager"}
          />
        </div>
      )}
      <TableLayout
        data={computedData}
        loading={loading}
        headers={tableHeaders.filter((header) =>
          visibleHeaders.includes(header.value)
        )}
        handleAction={handleViewAction}
      />

      <Pagination
        currentPage={currentPage}
        totalPages={totalPages}
        totalCount={totalCount}
        onPageChange={handlePageChange}
        itemsPerPage={itemsPerPage}
        onItemsPerPageChange={handleItemsPerPageChange}
      />
      {openDetailBox && (
        <DetailBox
          handleClose={() => setOpenDetailBox(false)}
          selectedObject={selectedObject}
          editIconVisibility={
            userRole !== "super_admin" && userRole !== "manager"
          }
        />
      )}
    </div>
  );
};

export default SalesReportOverview;